"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.uiSlice = void 0;
const models_1 = require("@creature-chess/models");
const toolkit_1 = require("@reduxjs/toolkit");
const types_1 = require("~/networking/types");
const initialState = {
    inGame: false,
    currentOverlay: null,
    selectedPieceId: null,
    winnerId: null,
    connectionStatus: types_1.ConnectionStatus.NOT_CONNECTED,
};
exports.uiSlice = (0, toolkit_1.createSlice)({
    name: "ui",
    initialState,
    reducers: {
        selectPiece: (state, { payload: id }) => {
            const isSamePiece = state.selectedPieceId !== null && state.selectedPieceId === id;
            state.selectedPieceId = isSamePiece ? null : id;
        },
        clearSelectedPiece: (state) => {
            state.selectedPieceId = null;
        },
        setInGameCommand: (state) => {
            state.inGame = true;
        },
        setConnectionStatusCommand: (state, { payload }) => {
            state.connectionStatus = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(models_1.ClientUi.openOverlayCommand, (state, { payload }) => {
            state.currentOverlay = payload;
        });
        builder.addCase(models_1.ClientUi.closeOverlayCommand, (state, { payload }) => {
            if (payload === undefined || state.currentOverlay === payload) {
                state.currentOverlay = null;
            }
        });
        builder.addCase(models_1.GameEvents.gameFinishEvent, (state, action) => {
            const winner = action.payload.players.find((p) => p.position === 1);
            if (winner) {
                state.winnerId = winner.id;
            }
        });
    },
});
exports.reducer = exports.uiSlice.reducer;
